import React from 'react';

interface FallbackUIProps {
  message?: string;
}

export const FallbackUI: React.FC<FallbackUIProps> = ({ message = 'Content coming soon' }) => {
  return (
    <div className="flex items-center justify-center py-12 px-6">
      <div className="glass-card rounded-2xl p-8 text-center max-w-md">
        <div className="w-12 h-12 rounded-full bg-vilarias-accent/20 flex items-center justify-center mx-auto mb-4">
          <div className="w-3 h-3 rounded-full bg-vilarias-accent animate-pulse" />
        </div>
        <p className="text-vilarias-text-secondary text-sm">{message}</p>
      </div>
    </div>
  );
};
